import React from 'react';
import moment from 'moment'
import { DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios'
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Divider } from '@material-ui/core';
import InputVirtual from 'components/InputVirtual'
import Backup from '@material-ui/icons/Backup';
import SweetAlert from 'react-bootstrap-sweetalert';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import License from './licenseList';

import { Card, CardBody, CardImg, CardSubtitle, CardText } from 'reactstrap';

import { BASE_URL_JAVAZ_API, BASE_HEADER, FILE_HEADER, BASE_URL_API } from "constants/ActionTypes";

const roleUser = localStorage.getItem('rolename')
const COMPANY_ID = localStorage.getItem('companyId')
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 20

const styles = theme => ({
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

const initialState = {
    // input virtual company
    company: 0,
    company_name: '',
    front_photo: null,
    back_photo: null,
    front_image: null,
    back_image: null,

    front_photo_license: null,
    back_photo_license: null,
    front_image_license: null,
    back_image_license: null,

    errorFullName: false,
    messageFullName: '',

    department: '',
    name: '',
    address: '',
    driver_code: '',
    mobile_no: '',
    birth_date: moment(),
    birth_place: '',
    hired_date: moment(),
    absent: false,
    status: false,
    username: '',
    password: '',
    email: '',
    imei_no: '',
    role_name: '',
    vehicle: 0,
    rfid: '',
    driver_type: '',


    // License Add Sim
    license_name: '',
    driver_license: null,
    license_exp_date: moment(),
    license_no: '',
    idxLicense: null,
    idLicense: null,

    licenseData: [],
    licenseDataEdit: [],
    departmentData: [],

    openSnack: false,
    messageSnack: '',
    sweetSuccess: false,
    sweetWarning: false,
    id: null,

    urlQr: '',
    urlPhoto: '',

    imageDialog: false,
    urlFrontImage: '',
    urlBackImage: '',
    loading: false
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class DialogAdd extends React.Component {
    constructor(props) {
        super(props);
    }

    state = initialState

    componentDidMount() {
        // console.log('edit modal')
        this.setState({ company: COMPANY_ID })
    }

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.data !== null) {
            if (nextProps.data.id !== prevState.id) {
                // console.log(nextProps.data.driver_license)
                return {
                    id: nextProps.data.id,
                    absent: nextProps.data.absent,
                    address: nextProps.data.address,
                    birth_date: moment(nextProps.data.birth_date, 'YYYY-MM-DD'),
                    birth_place: nextProps.data.birth_place,
                    company: nextProps.data.company,
                    driver_code: nextProps.data.driver_code,
                    driver_type: nextProps.data.driver_type,
                    email: nextProps.data.email,
                    hired_date: moment(nextProps.data.hired_date, 'YYYY-MM-DD'),
                    imei_no: nextProps.data.imei_no,
                    name: nextProps.data.name,
                    role_name: nextProps.data.role_name,
                    status: nextProps.data.status,
                    vehicle: nextProps.data.vehicle,
                    rfid: nextProps.data.rfid,
                    username: nextProps.data.username,
                    mobile_no: nextProps.data.mobile_no,
                    licenseData: nextProps.data.driver_license,
                    urlQr: nextProps.data.qrcode,
                    urlPhoto: nextProps.data.photo
                }
            }
        } else {
            return {
                username: ''
            }
        }

        return null
    }

    // input virtual company =====================================

    handleGetSelVirCompanyAddForm = ({ id }) => {
        // console.log(id)
        this.setState({ company: id })
    }
    //end input virtual company
    getInputVehicle = ({ id }) => {
        // console.log(id)
        this.setState({ vehicle: id })
    }

    getInputDriverLicense = ({ id, license_name }) => {
        // console.log(id)
        this.setState({ driver_license_id: id, license_name })
    }

    getInputRoleName = ({ role_name }) => {
        // console.log(role_name)
        this.setState({ role_name })
    }

    // Add module
    // Add module
    handleDateChange = (date) => {
        this.setState({ birth_date: date });
    };
    handleDateChange2 = (date) => {
        this.setState({ license_exp_date: date });
    };
    handleDateChange3 = (date) => {
        this.setState({ hired_date: date });
    };

    handleChangeCompanyType = event => {
        this.setState({
            company: event.target.value,
        });
    };
    handleChangeStatus = event => {
        this.setState({
            status: event.target.value,
        });
    };
    handleChangeStatusEdit = event => {
        this.setState({
            statusEdit: event.target.value,
        });
    };

    handleEditLicense = async obj => {
        let url = `${BASE_URL_JAVAZ_API}/driver-license-detail/new`
        const a = JSON.stringify(obj)
        const data = await axios.post(url, a, config).then(res => res).catch(error => error.response)
        return data
    }

    handleChangeFrontPhotoLicense = async data => {
        const { driver_license, data_front_photo } = data
        const { id } = this.state

        const formData = new FormData()
        formData.append(
            'file',
            data_front_photo,
            data_front_photo.name
        )
        // console.log(formData)
        // const obj = JSON.stringify(data)
        const url = `${BASE_URL_API}/driver-license-detail/change-front-photo/${id}/${driver_license}`
        const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
        return result
    }

    handleChangeBackPhotoLicense = async data => {
        const { driver_license, data_back_photo } = data
        const { id } = this.state

        const formData = new FormData()
        formData.append(
            'file',
            data_back_photo,
            data_back_photo.name
        )
        // console.log(formData)
        // const obj = JSON.stringify(data)
        const url = `${BASE_URL_API}/driver-license-detail/change-back-photo/${id}/${driver_license}`
        const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
        return result
    }

    handleAddLicenseDriver = async param => {
        const { id, driver_license_id, license_name, license_exp_date, license_no,
            licenseData, licenseDataEdit, front_photo_license, back_photo_license,
            front_image_license, back_image_license, loading } = this.state
        const licenseExpireDate = license_exp_date.format("YYYY-MM-DD")

        if (param === 'tambah') {
            if (license_name !== '' || license_no !== '') {
                const obj = {
                    driver: id,
                    license_name,
                    driver_license: driver_license_id,
                    license_exp_date: licenseExpireDate,
                    license_no,
                    data_front_photo: front_photo_license,
                    data_back_photo: back_photo_license,
                    front_photo: front_image_license,
                    back_photo: back_image_license
                }
                const result = await this.handleEditLicense(obj)

                if (front_photo_license != null) {
                    const resultFront = await this.handleChangeFrontPhotoLicense(obj)
                    if (resultFront.data.status !== true) {
                        NotificationManager.error(resultFront.data.message, 'Error message')
                    }
                }

                if (back_photo_license != null) {
                    const resultBack = await this.handleChangeBackPhotoLicense(obj)
                    if (resultBack.data.status !== true) {
                        NotificationManager.error(resultBack.data.message, 'Error message')
                    }
                }

                // console.log(result)
                if (result.data.status === true) {
                    const obj2 = {
                        id: result.data.data.id,
                        driver_license: driver_license_id,
                        license_exp_date: licenseExpireDate,
                        license_name,
                        license_no,
                        // front_photo,
                        // back_photo
                    }
                    this.setState({
                        openSnack: true,
                        front_photo_license: null,
                        back_photo_license: null,
                        front_image_license: null,
                        back_image_license: null,
                        messageSnack: 'Tambahkan SIM Success',
                        licenseData: [...licenseData, obj2],
                        licenseDataEdit: [...licenseDataEdit, obj2]
                    })
                } else {
                    this.setState({
                        openSnack: true,
                        messageSnack: 'Tambahkan SIM Error',
                    })
                }

                // console.log(licenseData)
            } else {
                this.setState({ openSnack: true, messageSnack: 'Please Insert data correctly' })
            }
        }

        this.setState({
            license_name: '',
            license_exp_date: moment(),
            license_no: '',
            front_photo: null,
            back_photo: null,
            front_image: null,
            back_image: null
        })
    }

    handleRemoveLicense = (data) => {
        // console.log(data)
        const { licenseData } = this.state
        const idx = licenseData.indexOf(data)
        this.setState({ sweetWarning: true, idxLicense: idx, idLicense: data.id })
    }

    deleteLicense = async id => {
        // console.log()
        const url = `${BASE_URL_JAVAZ_API}/driver-license-detail/delete/${id}`
        const result = await axios.delete(url, config).then(res => res).catch(error => error.response)
        // console.log(result)
        return result
    }

    handleDelete = async param => {
        if (param === 'batal') {
            // console.log(param)
            this.setState({
                sweetWarning: false,
            })
        } else if (param === 'delete') {
            const { licenseData, idxLicense, idLicense } = this.state
            const arr = JSON.parse(JSON.stringify(licenseData));

            const result = await this.deleteLicense(idLicense)
            // console.log(result)
            if (result.data.status === true) {
                arr.splice(idxLicense, 1)
                this.setState({ licenseData: arr, sweetWarning: false, sweetSuccess: true })
                // console.log(licenseData)
            } else {
                this.setState({ sweetWarning: false })
                NotificationManager.error(result.data.message, 'Error message')
            }


        }
    }
    //end Add mdule

    getFrontPhoto = event => {
        // console.log(URL.createObjectURL(event.target.files[0]))
        this.setState({
            front_photo: event.target.files[0],
            front_image: URL.createObjectURL(event.target.files[0])
        })


    }

    getBackPhoto = event => {
        // console.log(event.target.files[0])
        // console.log(URL.createObjectURL(event.target.files[0]))
        this.setState({
            back_photo: event.target.files[0],
            urlPhoto: URL.createObjectURL(event.target.files[0])
        })

    }

    getFrontPhotoLicense = event => {
        this.setState({
            front_photo_license: event.target.files[0],
            front_image_license: URL.createObjectURL(event.target.files[0])
        })

        // console.log(URL.createObjectURL(event.target.files[0]))
    }

    getBackPhotoLicense = event => {
        this.setState({
            back_photo_license: event.target.files[0],
            back_image_license: URL.createObjectURL(event.target.files[0])
        })

        // console.log(URL.createObjectURL(event.target.files[0]))
    }

    handleChangePhoto = async () => {
        const { back_photo, id } = this.state

        const formData = new FormData()
        formData.append(
            'file',
            back_photo,
            back_photo.name
        )
        // console.log(formData)
        // const obj = JSON.stringify(data)
        const url = `${BASE_URL_API}/driver/change-photo/${id}`
        const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
        return result
    }

    handleImageLicense = data => {
        // console.log(data)
        const frontImage = `${BASE_URL_API}/images/driver/${COMPANY_ID}/license/front_photo/${this.state.id}_${data.driver_license}.png?apikey=${token}`
        const backImage = `${BASE_URL_API}/images/driver/${COMPANY_ID}/license/back_photo/${this.state.id}_${data.driver_license}.png?apikey=${token}`

        this.setState({
            imageDialog: true,
            urlFrontImage: frontImage,
            urlBackImage: backImage
        })
    }

    handleSave = async (param) => {
        const { address, birth_date, birth_place, driver_code, mobile_no, rfid, status, company, name, vehicle,
            hired_date, absent, email, username, password, imei_no, role_name, licenseDataEdit, driver_type } = this.state


        const obj = {
            address,
            driver_code,
            mobile_no,
            rfid, status,
            vehicle: parseInt(vehicle),
            birth_place,
            company: parseInt(company),
            name,
            hired_date,
            absent,
            email,
            username,
            password,
            imei_no,
            driver_type,
            role_name,
            locked: false,
            birth_date: birth_date.format('YYYY-MM-DD'),
            hired_date: hired_date.format('YYYY-MM-DD'),
            // driver_license: licenseDataEdit
        }

        // console.log(obj)
        if (this.state.back_photo !== null && param !== 'batal') {
            const result = await this.handleChangePhoto()
            // console.log('upload photo')
            // console.log(result)
            if (result.data.status !== true) {
                NotificationManager.success(result.data.message, 'Error message')
            }
        }
        this.props.handleClose(param, obj)
        this.setState(initialState)
    }

    render() {
        const { classes, data, loading } = this.props
        const { licenseExpire, departmentData,
            licenseType, licenseData, birthDriverEdit, licenseExpireEdit, licenseTypeEdit, licenseDataEdit,
            errorFullName, messageFullName } = this.state;
        return (
            <React.Fragment>
                <NotificationContainer />
                <SweetAlert show={this.state.sweetSuccess} success title='Success' onConfirm={() => this.setState({ sweetSuccess: false })}>
                    License was successfully deleted !
                </SweetAlert>
                <SweetAlert show={this.state.sweetWarning}
                    warning
                    showCancel
                    confirmBtnText='Yes Delete!'
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title='Are You Sure?'
                    onConfirm={() => this.handleDelete('delete')}
                    onCancel={() => this.handleDelete('batal')}
                >
                    You want to delete this License!
                </SweetAlert>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.openSnack}
                    autoHideDuration={3000}
                    onClose={() => this.setState({ openSnack: false })}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.state.messageSnack}</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={() => this.setState({ openSnack: false })}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />

                <Dialog
                    fullScreen
                    open={this.props.openEdit}
                    onClose={() => this.props.handleClose('batal')}
                    TransitionComponent={Transition}>
                    <AppBar className="position-relative">
                        <Toolbar>
                            {/* <IconButton color="inherit" onClick={() => this.handleSave('batal')} aria-label="Close">
                        <CloseIcon />
                    </IconButton> */}
                            <Typography variant="h6" type="title" color="inherit" style={{
                                flex: 20,
                            }}>
                                Operator
                            </Typography>
                            <Button 
                                variant="contained" 
                                className="bg-white text-black"
						        disabled={loading} 
						        onClick={() => { if(!loading) this.props.handleClose('batal') }}
					        >
					    	    cancel
					        </Button>&nbsp;&nbsp;
					        <Button 
                                variant="contained" 
                                color="primary"
						        disabled={loading} 
						        onClick={() => { if(!loading) this.handleSave('ubah') }}
					        >
                                {loading ? (
                                    <CircularProgress
                                        className="text-white"
                                        size={24}
                                    />						  
                                ) : "save"}
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <div className="app-wrapper">
                        <Paper className={classes.paper} elevation={1}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <Typography variant="h6" gutterBottom>
                                        Form Driver
                                    </Typography>
                                    <Divider />

                                    <Grid container spacing={24}>
                                        <Grid item xs={6}>
                                            <InputVirtual
                                                required
                                                label="Perusahaan"
                                                value={data !== null ? data.join.company_name : ""}
                                                name="name"
                                                lengthData={20}
                                                url={BASE_URL_JAVAZ_API + "/company/search"}
                                                getData={this.handleGetSelVirCompanyAddForm}
                                                setData={[{ name: "id", value: this.state.company.toString(), "logic_operator": "=", "operator": "AND" }]}
                                                fullWidth={true}
                                                dialogForm="DialogFormCompany"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            {/* <InputVirtual
                                    required
                                    label="Role Name"
                                    value={this.state.role_name}
                                    name="role_name"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/master-role/search"}
                                    filter={[{name:"role_parent","logic_operator":"=",value:roleUser,"operator":"OR"},
                                             {name:"role_name","logic_operator":"=",value:roleUser,"operator":"OR"}]}
                                    getData={this.getInputRoleName}
                                    fullWidth={true}
                                /> */}
                                        </Grid>
                                    </Grid>

                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="drivercode"
                                        label="Kode Operator"
                                        type="text"
                                        value={this.state.driver_code}
                                        onChange={(e) => this.setState({ driver_code: e.target.value })}
                                        fullWidth
                                    />
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="rfid"
                                        label="RFID"
                                        type="text"
                                        value={this.state.rfid}
                                        onChange={(e) => this.setState({ rfid: e.target.value })}
                                        fullWidth
                                    />
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="driver_type"
                                        label="Tipe Operator"
                                        type="text"
                                        value={this.state.driver_type}
                                        onChange={(e) => this.setState({ driver_type: e.target.value })}
                                        fullWidth
                                    />
                                    <TextField
                                        required
                                        error={errorFullName}
                                        autoFocus
                                        margin="dense"
                                        id="fullname"
                                        label="Full Name"
                                        type="text"
                                        value={this.state.name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                        fullWidth

                                    />
                                    {errorFullName && <FormHelperText error={errorFullName} id="component-error-text">{messageFullName}</FormHelperText>}

                                    <Grid container spacing={24}>
                                        <Grid item xs={6}>

                                            {/* <TextField
                                    required
                                    autoFocus
                                    margin="dense"
                                    id="username"
                                    label="Username"
                                    type="text"
                                    value={this.state.username}
                                    onChange={(e) => this.setState({username: e.target.value})}
                                    fullWidth
                                    disabled
                                /> */}
                                            {/* <InputVirtual 
                                    label="Vehicle"
                                    value={data !== null ? data.join.vehicle_license_plate: ""}
                                    name="license_plate"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/vehicle/search"}
                                    getData={this.getInputVehicle}
                                    fullWidth={true}
                                /> */}
                                            <DatePicker
                                                fullWidth
                                                clearable
                                                label="Tanggal Lahir"
                                                value={this.state.birth_date}
                                                format="MMMM Do YYYY"
                                                onChange={this.handleDateChange}
                                                animateYearScrolling={false}
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                            />
                                            <DatePicker
                                                fullWidth
                                                clearable
                                                label="Tanggal Dipekerjakan"
                                                value={this.state.hired_date}
                                                format="MMMM Do YYYY"
                                                onChange={this.handleDateChange3}
                                                animateYearScrolling={false}
                                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    id="imeino"
                                    label="Imei No"
                                    type="number"
                                    value={this.state.imei_no}
                                    onChange={(e) => this.setState({imei_no: e.target.value})}
                                    fullWidth 
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="password"
                                    label="Password"
                                    type="password"
                                    onChange={(e) => this.setState({password: e.target.value})}
                                    fullWidth
                                /> */}
                                            <TextField
                                                required
                                                autoFocus
                                                margin="dense"
                                                id="email"
                                                label="Email"
                                                type="email"
                                                value={this.state.email}
                                                onChange={(e) => this.setState({ email: e.target.value })}
                                                fullWidth
                                            />
                                            <TextField
                                                autoFocus
                                                id="phone"
                                                label="Nomor HP"
                                                type="number"
                                                value={this.state.mobile_no}
                                                onChange={(e) => this.setState({ mobile_no: e.target.value })}
                                                fullWidth
                                            />

                                        </Grid>
                                    </Grid>

                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="place"
                                        label="Tempat Lahir"
                                        type="email"
                                        value={this.state.birth_place}
                                        onChange={(e) => this.setState({ birth_place: e.target.value })}
                                        fullWidth
                                    />

                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="address"
                                        label="Alamat"
                                        type="text"
                                        value={this.state.address}
                                        onChange={(e) => this.setState({ address: e.target.value })}
                                        fullWidth
                                    />
                                    <FormControlLabel
                                        value="left"
                                        control={
                                            <Switch
                                                checked={this.state.status}
                                                onChange={(e) => this.setState({ status: e.target.checked })}
                                                value="isActive"
                                                color="primary"
                                            />
                                        }
                                        label="Status "
                                    />
                                    {/* <FormControlLabel
                                value="left"
                                control={
                                    <Switch
                                    checked={this.state.absent}
                                    onChange={(e) => this.setState({absent: e.target.checked})}
                                    value="isActive"
                                    color="primary"
                                    />
                                }
                                label="Absent "
                        /> */}

                                    <br /><br />
                                    <Grid container spacing={24}>
                                        <Grid item xs={6}>
                                            <div>
                                                <img src={this.state.urlQr} height="200"></img>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div>
                                                {/* <img src={this.state.urlPhoto} height="200"></img> */}
                                                <br /><br />
                                                <Paper className={classes.paper} elevation={1}>
                                                    <img width="100%" height="150" src={this.state.urlPhoto !== '' ? this.state.urlPhoto : 'https://via.placeholder.com/150x150'} style={{
                                                        borderRadius: 5,
                                                        boxShadow: '0 0 7px 2px rgba(204,204,204,0.7)'
                                                    }} />
                                                </Paper><br />
                                                <input
                                                    onChange={this.getBackPhoto}
                                                    style={{ display: 'none' }}
                                                    type="file"
                                                    ref={fileInputPhotoDriver => this.fileInputPhotoDriver = fileInputPhotoDriver} />
                                                <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputPhotoDriver.click()}>
                                                    <Backup /> &nbsp;&nbsp;
                                                    <span>Upload Photo</span>
                                                </Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h6" gutterBottom style={{ marginLeft: 20 }}>
                                        <i className="zmdi zmdi-assignment"></i>&nbsp; Tambahkan SIM Operator
                                    </Typography>
                                    <Divider /><br />
                                    <ExpansionPanel defaultExpanded={false}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <div >
                                                <Typography> <i class="zmdi zmdi-plus zmdi-hc-lg"></i>&nbsp;&nbsp; Tambahkan SIM</Typography>
                                            </div>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails>
                                            <Grid container spacing={24}>
                                                <Grid item xs={12}>

                                                    <InputVirtual
                                                        label="License Type"
                                                        value=""
                                                        name="license_name"
                                                        lengthData={20}
                                                        url={BASE_URL_JAVAZ_API + "/driver-license/search"}
                                                        getData={this.getInputDriverLicense}
                                                        fullWidth={true}
                                                        dialogForm="DialogFormDriverLicense"
                                                    />


                                                    <DatePicker
                                                        fullWidth
                                                        clearable
                                                        label="Expire Date"
                                                        value={this.state.license_exp_date}
                                                        format="MMMM Do YYYY"
                                                        onChange={this.handleDateChange2}
                                                        animateYearScrolling={false}
                                                        leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                                        rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                                    />
                                                    <TextField
                                                        autoFocus
                                                        margin="dense"
                                                        id="license_no"
                                                        label="License Number"
                                                        type="number"
                                                        value={this.state.license_no}
                                                        onChange={(e) => this.setState({ license_no: e.target.value })}
                                                        fullWidth
                                                    /><br /><br />
                                                    <Grid container spacing={24}>
                                                        <Grid item xs={6}>
                                                            <Paper className={classes.paper} elevation={1}>
                                                                <img width="100%" height="150" src={this.state.front_image_license !== null ? this.state.front_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                                    borderRadius: 20,
                                                                    boxShadow: '0 0 7px 2px rgba(204,204,204,0.7)'
                                                                }} />
                                                            </Paper><br />
                                                            <input
                                                                onChange={this.getFrontPhotoLicense}
                                                                style={{ display: 'none' }}
                                                                type="file"
                                                                ref={fileInputFront => this.fileInputFront = fileInputFront} />
                                                            <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputFront.click()}>
                                                                <Backup /> &nbsp;&nbsp;
                                                                <span>Upload Front Image</span>
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Paper className={classes.paper} elevation={1}>
                                                                <img width="100%" height="150" src={this.state.back_image_license !== null ? this.state.back_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                                    borderRadius: 20,
                                                                    boxShadow: '0 0 7px 2px rgba(204,204,204,0.7)'
                                                                }} />
                                                            </Paper><br />
                                                            <input
                                                                onChange={this.getBackPhotoLicense}
                                                                style={{ display: 'none' }}
                                                                type="file"
                                                                ref={fileInputBack => this.fileInputBack = fileInputBack} />
                                                            <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputBack.click()}>
                                                                <Backup /> &nbsp;&nbsp;
                                                                <span>Upload Back Image</span>
                                                            </Button>
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </ExpansionPanelDetails>
                                        <Divider />
                                        <ExpansionPanelActions>
                                            <Button size="small" onClick={() => this.handleAddLicenseDriver('batal')}>
                                                Cancel
                                            </Button>
                                            <Button size="small" color="primary" onClick={() => this.handleAddLicenseDriver('tambah')}>
                                                Save
                                            </Button>
                                        </ExpansionPanelActions>
                                    </ExpansionPanel>
                                    <br /><br />
                                    <div className="sticky-container">
                                        <Typography variant="h6" gutterBottom style={{ marginLeft: 20 }}>
                                            <i className="zmdi zmdi-assignment"></i>&nbsp; Daftar SIM Operator
                                        </Typography>
                                        <Divider />
                                        <Dialog
                                            fullWidth="true"
                                            maxWidth="sm"
                                            open={this.state.imageDialog}
                                            onClose={() => this.setState({ imageDialog: false })}
                                            TransitionComponent={Transition}
                                            keepMounted
                                            aria-labelledby="alert-dialog-slide-title"
                                            aria-describedby="alert-dialog-slide-description"
                                        >
                                            <DialogTitle id="max-width-dialog-title">Image License</DialogTitle>
                                            <DialogContent>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Card className="shadow border-0">
                                                            <CardImg top width="100%" src={this.state.urlFrontImage} alt="Card image cap" />
                                                            <CardBody>
                                                                <h3 className="card-title">Front Image</h3>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Card className="shadow border-0">
                                                            <CardImg top width="100%" src={this.state.urlBackImage} alt="Card image cap" />
                                                            <CardBody>
                                                                <h3 className="card-title">Back Image</h3>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                </div>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button variant="contained" className="bg-white text-black" onClick={() => this.setState({ imageDialog: false })}>
                                                    Close
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                        {licenseData.length > 0 ? (
                                            <License license={licenseData} deleteLicense={this.handleRemoveLicense} handleShowImage={this.handleImageLicense} />
                                        ) : (
                                            <div style={{ margin: '20% 0 0 40%' }}>
                                                <i className="zmdi zmdi-alert-triangle zmdi-hc-5x" style={{ opacity: '0.3', marginLeft: 20 }}></i>
                                                <Typography>Tidak ada SIM yang Terdaftar</Typography>
                                            </div>

                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>
                    </div>

                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(DialogAdd);


// WEBPACK FOOTER //
// ./app/routes/MasterDriver/DialogEdit.js